import isDeepEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';
import memoizeOne from 'memoize-one';
function identity(value) {
  return value;
}
const deepMemoized = memoizeOne(identity, isDeepEqual);
export function isIndexRoute(leafRoute) {
  if (!leafRoute) {
    return true;
  }
  return !!(leafRoute.handle?.tracking && (leafRoute.handle.tracking.chapter3 || leafRoute.handle.tracking.chapter2 || leafRoute.handle.tracking.chapter1));
}
function sanitizeName(name) {
  if (!name) {
    return 'default';
  }
  return name.replace(/\s/g, '_') || 'default';
}
function getName(value, params) {
  const paramIndex = value.search(':');
  if (paramIndex > -1) {
    const namedValue = params[value.slice(paramIndex + 1)];
    const fullValue = namedValue ? value.replace(/:[^/]+/, namedValue) : '';
    return sanitizeName(fullValue);
  }
  return sanitizeName(value);
}
export const stripRouteParamsPattern = /(?:\(?\/:[^/]+\)?)/g;
export const stripParentRoutePathPattern = /^(?:\/?.*\/)*/g;
export function extractSlug(matches) {
  const routes = matches.filter(match => match.pathname || match.handle?.tracking);
  const leafRoute = routes[routes.length - 1];
  if (!leafRoute || leafRoute.pathname === '/' || isIndexRoute(leafRoute)) {
    return 'default';
  }
  const path = leafRoute.pathname || '';
  return sanitizeName(path.replace(stripRouteParamsPattern, '').replace(stripParentRoutePathPattern, ''));
}
export function getTrackingProps(matches, {
  ignoreParams = false
} = {}) {
  const params = !ignoreParams ? matches[matches.length - 1]?.params : {};
  const trackedRoutes = matches.filter(match => Boolean(match.handle?.tracking));
  if (!trackedRoutes.length) {
    return undefined;
  }
  const routesTrackingProps = pickBy(trackedRoutes.reduce((prev, match) => {
    if (!prev) {
      return match.handle.tracking;
    }
    let prefix = prev.prefix || match.handle.tracking.prefix;
    if (prev.prefix && match.handle.tracking.prefix) {
      prefix = prev.prefix + match.handle.tracking.prefix;
    }
    return {
      ...prev,
      ...match.handle.tracking,
      prefix
    };
  }, undefined), identity);
  const trackingProps = Object.assign({}, ...Object.keys(routesTrackingProps).map(param => {
    let value = routesTrackingProps[param];
    value = typeof value === 'string' ? getName(value, params) : value;
    if (value === 'default' && param !== 'name') {
      return {};
    }
    return {
      [param]: value
    };
  }));
  if (!trackingProps || trackingProps.noTrack) {
    return undefined;
  }
  if (!trackingProps.name) {
    trackingProps.name = extractSlug(matches);
  }
  if (trackingProps.prefix) {
    trackingProps.name = `${trackingProps.prefix}${trackingProps.name}`;
    delete trackingProps.prefix;
  }
  return trackingProps;
}
export { deepMemoized };